export default "__VITE_ASSET__0c13221d__"